// extracted by mini-css-extract-plugin
export default {"nav":"Header_nav__J8WFt","a":"Header_a__hxz3O","back":"Header_back__C7M14"};